import { useLayoutEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Renames old deep-link query params to their filter keys, once, in place (replace), so
 * links that predate the filter panel (e.g. /users?role_id=… from the Roles list) still
 * land on the same filtered view and show it as a chip. map: { oldKey: newKey }.
 */
export default function useLegacyQueryParams(map) {
    const location = useLocation();
    const navigate = useNavigate();
    useLayoutEffect(() => {
        const sp = new URLSearchParams(location.search);
        let changed = false;
        Object.entries(map).forEach(([from, to]) => {
            if (!sp.has(from)) return;
            const v = sp.get(from);
            sp.delete(from);
            if (v && !sp.get(to)) sp.set(to, v);
            changed = true;
        });
        if (changed) {
            const next = sp.toString();
            navigate({ pathname: location.pathname, search: next ? `?${next}` : '' }, { replace: true });
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.search]);
}
